import { type FC, useRef, useCallback } from "react";
import type { Video } from "../../types";
import styles from "./PhotoViewer.module.css";

const getVideoMimeType = (src: string): string => {
  const cleanSrc = src.split("?")[0]?.split("#")[0] ?? src;
  const ext = cleanSrc.slice(cleanSrc.lastIndexOf(".") + 1).toLowerCase();

  switch (ext) {
    case "webm":
      return "video/webm";
    case "ogg":
    case "ogv":
      return "video/ogg";
    case "mp4":
    default:
      return "video/mp4";
  }
};

type Props = {
  item: Video;
};

export const PhotoViewerVideoSlide: FC<Props> = ({ item }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleClick = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }, []);

  return (
    <div className={styles.videoContainer} onClick={handleClick}>
      <video
        ref={videoRef}
        className={styles.slideVideo}
        poster={item.thumbnailSrc}
        controls={false}
        playsInline
        preload="metadata"
      >
        <source src={item.src} type={getVideoMimeType(item.src)} />
      </video>
    </div>
  );
};
